import GoogleCalendar from '@/assets/media/img/GoogleCalendar.png'

import GoogleContacts from '@/assets/media/img/GoogleContacts.png'

import GoogleTasks from '@/assets/media/img/GoogleTasks.png'

import GoogleKeep from '@/assets/media/img/GoogleKeep.png'

export const side_bar_features = [
    {
        img: GoogleCalendar,
        title: 'Calendar',
        link: '/calendar'
    },
    {
        img: GoogleContacts,
        title: 'Contacts',
        link: '/contacts'
    },
    {
        img: GoogleKeep,
        title: 'Keep',
        link: '/keep'
    },
    {
        img: GoogleTasks,
        title: 'Tasks',
        link: '/keep'
    },
]